import React from 'react'
import classnames from 'classnames/bind'
import * as graph from '@adc/sdk'
import {
  CurrentTargetAudience,
  OnlineAuctionSegmentBidRank,
} from '@adc/sdk/types'
import styles from './index.scss'
// @ts-ignore no types
import { InfoPill } from '../../../../elementals'
import Text from '../../../../elementals/text'
const cx = classnames.bind(styles)

export type BidRankTermsProps = {
  bidRank: OnlineAuctionSegmentBidRank
  viewingFrom?: CurrentTargetAudience
  requestRentBack?: boolean
}

const formatPaymentType = (type: string) => {
  const paymentTypeMap: Record<string, string> = {
    CASH: 'Cash',
    CONVENTIONAL: 'Conventional Financing',
    FHA: 'FHA Financing',
    VA: 'VA Financing',
    USDA: 'USDA Financing',
    REHAB_LOAN: 'Rehab Loan',
    LINE_OF_CREDIT: 'Line of Credit',
    HARD_MONEY_LOAN: 'Hard Money Loan',
    OTHER: 'Other',
  }
  return paymentTypeMap[type] || 'Other'
}

const BidRankTerms = ({
  bidRank,
  viewingFrom = graph.enums.CurrentTargetAudience.Seller,
  requestRentBack,
}: BidRankTermsProps) => {
  const terms = bidRank?.bid?.terms

  const conditions = [
    {
      key: 'payment-type',
      content: formatPaymentType(terms?.payment_type || ''),
      enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
    },
    {
      key: 'rent-back',
      content:
        terms?.leaseback_duration != null && terms.leaseback_duration > 0
          ? `${terms.leaseback_duration} days of Rent Back`
          : requestRentBack
          ? 'No Rent Back'
          : null,
      enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
    },
    {
      key: 'emd',
      content: terms?.earnest_money_deposit_amount
        ? `EMD of $${terms.earnest_money_deposit_amount.toLocaleString()}`
        : null,
      enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
    },
    {
      key: 'closing',
      content: terms?.close_escrow_duration
        ? `${terms.close_escrow_duration} Days to Close`
        : null,
      enabled: true,
    },
    {
      key: 'option-period',
      content:
        terms?.inspection_contingency_period_duration != null
          ? `Option Period of ${terms.inspection_contingency_period_duration} days`
          : null,
      enabled: viewingFrom !== graph.enums.CurrentTargetAudience.Buyer,
    },
  ]

  return (
    <div className={cx('conditions-container')}>
      {conditions
        .filter(condition => condition.content != null && condition.enabled)
        .map((condition, index) => (
          <InfoPill
            key={`${bidRank.bid_id}-${condition.key}-${index}`}
            data-elm-id={`${bidRank.bid_id}-${condition.key}`}
            content={<Text size='tiny'>{condition.content} </Text>}
            size='medium'
            fontWeight='normal'
          />
        ))}
    </div>
  )
}

export default BidRankTerms
